module.exports = __webpack_public_path__ + "static/media/call-icon-2.81b4dc19.svg";